// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_link_content-module__container--1H7dy"};